// DAS-2181: Terminal Annotation Overlay — text comments pinned to regions
import React, { useState, useRef, useEffect } from 'react';

const TerminalAnnotation = ({ target, annotations = [], onSave, onCancel }) => {
  const [text, setText] = useState('');
  const textareaRef = useRef(null);

  useEffect(() => {
    textareaRef.current?.focus();
  }, [target]);

  const handleSave = () => {
    const trimmed = text.trim();
    if (!trimmed) return;
    onSave(trimmed);
    setText('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && (e.metaKey || e.ctrlKey)) {
      e.preventDefault();
      handleSave();
    }
    if (e.key === 'Escape') {
      onCancel();
    }
  };

  const openAnns = annotations.filter(a => a.status === 'open');
  const resolvedAnns = annotations.filter(a => a.status === 'resolved' || a.status === 'wontfix');

  const renderAnnotationList = () => (
    <>
      {openAnns.map(ann => (
        <div className="annotation-existing" key={ann.id}>
          <div className="ann-text">{ann.text}</div>
          <div className="ann-meta">{new Date(ann.timestamp).toLocaleString()}</div>
        </div>
      ))}
      {resolvedAnns.length > 0 && (
        <div style={{ marginTop: 4 }}>
          <div style={{ fontSize: 8, color: '#3a4555', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 2 }}>
            resolved ({resolvedAnns.length})
          </div>
          {resolvedAnns.map(ann => (
            <div className="annotation-existing annotation-resolved" key={ann.id}>
              <div className="ann-text" style={{ textDecoration: 'line-through', opacity: 0.5 }}>{ann.text}</div>
              {ann.response && (
                <div className="ann-response">{ann.response}</div>
              )}
              <div className="ann-meta">{new Date(ann.timestamp).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </>
  );

  const renderInput = () => (
    <div className="annotation-input-container">
      <div style={{ marginBottom: 6, color: '#7a8fa6', fontSize: 9, letterSpacing: '0.08em', textTransform: 'uppercase' }}>
        {target.regionLabel || target.regionId}
      </div>

      {renderAnnotationList()}

      <textarea
        ref={textareaRef}
        value={text}
        onChange={e => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Add design feedback..."
      />
      <div className="annotation-input-actions">
        <button onClick={onCancel}>cancel</button>
        <button className="save" onClick={handleSave}>save (Cmd+Enter)</button>
      </div>
    </div>
  );

  const regionElement = document.querySelector(`[data-region="${target.regionId}"]`);

  if (!regionElement) {
    return (
      <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1000 }}>
        {renderInput()}
      </div>
    );
  }

  const rect = regionElement.getBoundingClientRect();

  return (
    <div style={{ position: 'fixed', top: rect.bottom + 4, left: rect.left, zIndex: 1000 }}>
      {renderInput()}
    </div>
  );
};

export default TerminalAnnotation;
